import { Controller } from '@hotwired/stimulus';
import { MinimalHeaderController } from '@elc-online/edl-components/js/minimal_header';

export default class extends Controller {
  static readonly targets = ['button'];
  declare buttonTarget: HTMLAnchorElement;
  private controller: MinimalHeaderController;

  initialize(): void {
    this.controller = new MinimalHeaderController(
      {
        back: this.buttonTarget,
      },
      {
        mode: 'auto',
      },
    );
  }

  connect() {
    this.controller.connect();
  }

  disconnect() {
    this.controller.disconnect();
  }
}
